import { Box, Button, Stack, styled, Typography, Theme } from '@mui/material';
import { isBrowser } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import CabinetBgLogoIcon from '../../assets/icons/cabinetBgLogoIcon.svg?react';
import ChargingBatteryIcon from '../../assets/icons/chargingBatteryIcon.svg?react';

const StyledMain = styled('main')(() => ({
  flex: '1 1 auto',
  backgroundColor: '#353434',
  maxWidth: !isBrowser ? '100%' : '400px',
}));

export const NorFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <StyledMain>
      <Stack
        sx={(theme: Theme) => ({
          position: 'relative',
          maxWidth: !isBrowser ? '100%' : '400px',
          width: '100%',
          backgroundColor: theme.palette.gray[300],
          alignItems: 'center',
          overflow: 'hidden',
        })}
      >
        <CabinetBgLogoIcon
          width="100%"
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        />
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ zIndex: 2, height: '100%', width: '100%', gap: '50px' }}
        >
          <Stack direction="row" alignItems="center" sx={{ gap: '4px' }}>
            <Typography color="common.white" sx={{ fontSize: '40px' }}>
              4
            </Typography>
            <ChargingBatteryIcon />
            <Typography color="common.white" sx={{ fontSize: '40px' }}>
              4
            </Typography>
          </Stack>

          <Stack alignItems="center" sx={{ gap: '15px' }}>
            <Typography color="common.white" variant="body1" textAlign="center">
              {t('notFoundPage.firstLineText')} <br />{' '}
              {t('notFoundPage.secondLineText')}
            </Typography>
            <Box sx={{ maxWidth: 'max-content', marginTop: '50px' }}>
              <Button onClick={() => navigate('/')} variant="contained">
                {t('goToHomePage')}
              </Button>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </StyledMain>
  );
};
